module.exports = __webpack_public_path__ + "static/tira-duvidas-aa7738bf3399d7198e7eccb3d56545fb.jpg";